var userStoreGetters;
(function (userStoreGetters) {
    userStoreGetters["GET_ME"] = "GET_ME";
    userStoreGetters["GET_NAME"] = "GET_NAME";
    userStoreGetters["GET_USER_ROLE"] = "GET_USER_ROLE";
    userStoreGetters["HAS_CONTACT_PERSON"] = "HAS_CONTACT_PERSON";
    userStoreGetters["IS_SWEDISH_POSTAL_CODE"] = "IS_SWEDISH_POSTAL_CODE";
    userStoreGetters["GET_ADDRESS_INFO"] = "GET_ADDRESS_INFO";
    userStoreGetters["GET_AGENT"] = "GET_AGENT";
})(userStoreGetters || (userStoreGetters = {}));
export default userStoreGetters;
